import { useState, useEffect, useRef } from "react";
import "./choose_prof.css";
import { apiFetch } from "../../config";

function ChooseProf({ selectedProf, setSelectedProf }) {
    const [profs, setProfs] = useState([]);
    const [search, setSearch] = useState("");
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        apiFetch("/professeurs")
            .then((res) => res.json())
            .then((data) => setProfs(data))
            .catch((err) => console.error("Erreur récupération professeurs :", err));
    }, []);

    // Fermer la liste si clic en dehors
    useEffect(() => {
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const filtered = profs.filter((p) =>
        `${p.prenom} ${p.nom}`.toLowerCase().includes(search.toLowerCase())
    );

    const handleSelect = (prof) => {
        setSelectedProf(`${prof.nom} ${prof.prenom}`);
        setSearch(`${prof.prenom} ${prof.nom}`);
        setOpen(false);
    };

    return (
        <div className="ChooseProf" ref={ref}>
            <label htmlFor="prof-search">Choisir un professeur :</label>
            <input
                id="prof-search"
                type="text"
                placeholder="Rechercher..."
                value={search}
                onChange={(e) => { setSearch(e.target.value); setSelectedProf(""); setOpen(true); }}
                onFocus={() => setOpen(true)}
                autoComplete="off"
            />
            {open && filtered.length > 0 && (
                <ul className="prof-dropdown">
                    {filtered.map((prof) => (
                        <li key={prof.id} onMouseDown={() => handleSelect(prof)}>
                            {prof.prenom} {prof.nom}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default ChooseProf;
